import { render, staticRenderFns } from "./MonthlySocsoHSBC.vue?vue&type=template&id=7bf3fe14"
import script from "./MonthlySocsoHSBC.vue?vue&type=script&lang=js"
export * from "./MonthlySocsoHSBC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports